<section class="mt-4">
  <ngx-loading [show]="isLoading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>

  <div id="quotation" class="quotation" #quotationCaptureContent>
    <app-quote-form (handleOnSubmit)="onSubmit($event)" [errorMessageType]="getPriceErrorType" [ngClass]="{ hide: !showQuoteForm }">
    </app-quote-form>

    <app-quote-summary
      (handleOnEdit)="onSubmit($event)"
      [ngClass]="{ hide: !showQuoteSummary }"
      [currentQuoteData]="currentQuoteData"
    ></app-quote-summary>

    <div id="quotation__product-detail" class="quotation__product-detail" [ngClass]="{ hide: !showProductDetail }">
      <app-product-detail
        [productDetailData]="productDetailData"
        [currentQuoteData]="currentQuoteData"
        [errorMessageType]="getPriceErrorType"
      ></app-product-detail>
    </div>

    <div id="quotation__button-group" class="quotation__button-group" *ngIf="showButtonGroup">
      <div class="row center">
        <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 offset-xl-3">
          <button
            id="captureImageButton"
            type="submit"
            (click)="onCaptureImageClick()"
            class="btn btn-app-primary btn-round box-shadow"
            [disabled]="disabled"
            data-testId="captureImageBtn"
          >
            {{ 'captureImage' | translate }}
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2">
          <button
            id="sendEmailButton"
            type="submit"
            (click)="onSendEmailClick()"
            class="btn btn-app-primary"
            [disabled]="disabled"
            data-testId="sendEmailBtn"
          >
            {{ 'sendEmail' | translate }}
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-2">
          <button
            id="buyNowButton"
            type="submit"
            (click)="onBuyNowClick()"
            class="btn btn-app-primary"
            [disabled]="disabled"
            data-testId="buyNowBtn"
          >
            {{ 'buyNow' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
